// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-9b7d5270]{max-height:200px}", "",{"version":3,"sources":["webpack://./resources/components/table/MediaCell.vue"],"names":[],"mappings":"AAIA,qBACE,gBAHF","sourcesContent":["@import \"../../scss/variables/color\";\n@import \"../../scss/variables/container-max-widths\";\n\n\nimg {\n  max-height: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
